import { matchPath } from "react-router-dom";

// ----------------------------------------------------------------------

export { default as NavSectionHorizontal } from "./horizontal";
export { default as NavSectionVertical } from "./vertical";

export function isExternalLink(path: string) {
  return path.includes("http");
}

export function getActive(path: string, pathname: string, asPrefix: boolean = false) {
  // Remove query parameters from path for matching
  const cleanPath = path.split("?")[0];
  return cleanPath
    ? !!matchPath({ path: cleanPath, end: !asPrefix }, pathname)
    : false;
}
